import { render } from "./App.vue?vue&type=template&id=2ce4b113&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2ce4b113&lang=css"
import "./App.vue?vue&type=style&index=1&id=2ce4b113&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/give-circle-intro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce4b113"]])

export default __exports__